import { useState } from "react";

// @mui
import { AUTH_JWT_TOKEN, AUTH_REFRESH_TOKEN, Avatar, IconButton, Menu, MenuItem } from "@compass/core";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppAuthStatus } from "redux/reducers/appSlice";
import { RootState } from "redux/store";

import ApiService from "services/apiService";
import { userManualPageRoute } from "pages/UserManual/UserManualPage";

export const AppTopBarUserMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appUserFullName = useSelector((state: RootState) => state.app.userFullName);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(null);

  const logout = () => {
    const refreshToken: string | null = localStorage.getItem(AUTH_REFRESH_TOKEN);
    localStorage.removeItem(AUTH_JWT_TOKEN);
    localStorage.removeItem(AUTH_REFRESH_TOKEN);

    if (refreshToken) {
      ApiService.auth.logout(refreshToken);
    }

    dispatch(setAppAuthStatus("NOT_AUTHENTICATED")); // tell redux we are authenticated
  };

  const userManual = () => {
    navigate(userManualPageRoute.getPath());
  }  

  return (
    <>
      <IconButton onClick={(e) => setUserMenuAnchorEl(e.currentTarget)}>
        {appUserFullName && <Avatar string={appUserFullName} />}
      </IconButton>

      <Menu anchorEl={userMenuAnchorEl} open={Boolean(userMenuAnchorEl)} onClose={() => setUserMenuAnchorEl(null)}>
        <MenuItem onClick={userManual}>User Manual</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};
